const debounce = (func, wait, immediate) => {
    let timeout

    return function () {
        const context = this, args = arguments
        const later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }

        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}


/* Autocomplete Search */
const s_autocomplete = debounce((s, params = { prefix : '', displayElement: '.rs-view', limit: 3, moreResults: true }) => {


    var rs = document.querySelector(params.displayElement)

    // Show
    if (s.value.length > 2) {
      fetchProducts(s)
    } else {
      clearAutoComplete()
    }


    // Hide 
    document.addEventListener('click', function (event) {
        var isClickInside = s.contains(event.target);
        if (!isClickInside) {
            rs.style.display = "none";
        } else {
          	rs.style.display = "inherit";
        }
      

    });
    
    // Request
    function fetchProducts(s) {
        showAutoComplete();
      	
      	var searchValue = s.value
        if(!searchValue.toUpperCase().startsWith(params.prefix.toUpperCase())) {
          searchValue = params.prefix + searchValue
        }
      
        // Do api lookup
        // We want to get the Title, SKU, Image, Price, Availability
        fetch('/search?q='+ searchValue + '&view=json&pagination='+params.limit).then(response => response.json()).then(data => {
         
          for (i = 0; i < data.products.reverse().length; i++) {
            var d = data.products[i];
            var row = { image: d.featured_image, title: d.title, price: d.price, sku: d.sku, instock: d.available, handle: d.handle }
            autoCompleteTemplate(row, i);
          }
          
          if(data.products.length>0) {
            if(params.moreResults) {
            	rs.innerHTML += `<a href="/search?q=${s.value}"><div class="s_more">See all results</div></a>`
            }
          } else {
            rs.innerHTML += `<a href="/search?q=${s.value}"><div class="s_more">We couldn't find anything</div></a>`
          }
          
        });
    }
    
    function clearAutoComplete() {
        rs.textContent = null
        rs.innerHtml = null
        rs.style.display = "none";
    }
    
    function showAutoComplete() {
        clearAutoComplete();
        rs.style.display = "block";
    }
    
    function autoCompleteTemplate(d, index) {    
        var money = Shopify.formatMoney(d.price);
        var stock = function (d) {
            return ''
            if (d.available)
                return `<span class="s_avail in">instock</span>`
            return `<span class="s_avail out">sold out</span>`
        }
    
        var html = `
           <a href="/products/${d.handle}" data-index="${index}">
           <div class="s_row">
             <div class="s_image"><img src="${d.image}" /></div>
             <div class="s_info">
             <div class="s_title">${d.title}</div>
             <div class="s_price">${money} ${stock(d)}</div>
             <div class="s_sku"></div>
           </div>
           </div>
           </a>`;
        rs.innerHTML += html;
    }
    
    // Arrow select functions
    s.onkeydown = function (e) {
        if (!rs) { // If no response view
            return;
        }
    
        var s_max = jQuery("a[data-index]").length;
        var s_index = 0;
    
        switch (e.which) {
    
            case 38: // up
                if (s_max > 0 && s_index <= s_max) {
                    s_index = s_index--;
                    jQuery("a[data-index=" + s_index + "]").focus().hover()
                } else {
                    jQuery("a[data-index=0").focus().hover()
                }
                break;
    
            case 40: // down
                if (s_max > 0 && s_index <= s_max) {
                    s_index = s_index++;
                    console.log('s_max > 0 & s_index <= max', s_index)
    
                    jQuery("a[data-index=" + s_index + "]").focus().hover()
                } else {
                    console.log('else', s_index)
                    jQuery("a[data-index=0").focus().hover()
                }
                break;
    
            default: return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    }
}, 300)
/* END Autocomplete Search */



/*
	Dispatch within ... h m s
    Weekdays only, use id="shipping_time"
*/
function isWeekday() {
  	var start = setDispatchTime();
 	var today = new Date;
  	// If After Friday 1pm, Saturday or Sunday
	if((today.getDay() == 6 || today.getDay() == 0) || (today.getDay() == 5 && today > start)) {
      return false;
    }
  	return true;
}

function setDispatchTime() {
    var start = new Date;
    start.setHours(13, 00, 0);// 1:00pm
  	return start;
}

// Self invoking func.
(function() {
  var start = setDispatchTime();
  
  function pad(num) {
    return ("0" + parseInt(num)).substr(-2);
  }

  function tick() {
    var now = new Date;
    if(isWeekday()) {
      if (now > start) { // too late, go to tomorrow
        // start.setDate(start.getDate() + 1);
        document.getElementById('shipping_time').innerHTML =
        'Next Dispatch: Tomorrow 1pm AEST';
        return;
      }
      var remain = ((start - now) / 1000);
      var hh = pad((remain / 60 / 60) % 60);
      var mm = pad((remain / 60) % 60);
      var ss = pad(remain % 60);
      document.getElementById('shipping_time').innerHTML =
        'Next Dispatch: ' + parseInt(hh) + "h " + parseInt(mm) + "m " + parseInt(ss) + "s";
      setTimeout(tick, 1000);
    } else {
      document.getElementById('shipping_time').innerHTML =
        'Next Dispatch: Monday 1pm AEST';
    }
  }

  document.addEventListener('DOMContentLoaded', tick);
  
})();
/* END Dispatch Code */

/* Hover Nav adjustment */
$(document).on('mouseover','.site-nav__item',function(){
    $('.site-nav__link').removeClass('meganav--active');
    $('.site-nav__dropdown').removeClass('meganav--active');
    $(this).find('.site-nav__link').addClass('meganav--active');
    $(this).find('.site-nav__dropdown').addClass('meganav--active');
})
$(document).on('mouseover','.page-container',function(e){
     var container = $(".site-nav__dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0) {

        $('.site-nav__link').removeClass('meganav--active');
       $('.site-nav__dropdown').removeClass('meganav--active');
     }
})
$(document).on('mouseover','.site-header__upper',function(e){
     var container = $(".site-nav__dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0) {

        $('.site-nav__link').removeClass('meganav--active');
       $('.site-nav__dropdown').removeClass('meganav--active');
     }
})
/* END Hover Nav adjustment */



/**
 * Observe Changes to the DOM
 */
const observer = new MutationObserver(function (mutations_list) {
    mutations_list.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            // If Vitals Search
            if (node.id == 'vitals-instant-search') {
                const search = node.querySelector("input.vitals-search-input") || null
                if (search) {
                    search.addEventListener('input', (evt) => {
                        const searchReplace = debounce((evt) => {
                            var value = evt.target.value.replace(/(?<![* ])\s+/g, "* ")
                            updateValue(search, value)
                            // return evt.target.value.replaceAll(' ', '* ')
                        }, 1000)
                        searchReplace(evt)
                    });
                }
                // observer.disconnect();
            }
        });
    });
});

observer.observe(document.querySelector("body"), { subtree: false, childList: true });

// Update Value
const updateValue = (element, value) => {
    element.value = value
}


/**
  DISCOUNT CODES TO DISPLAY;
  USED IN SNIPPET `product-discount-code-display`
*/
var activeDiscounts = [];
var discountsToLookup = ['SUMMER'];

async function doesDiscountCodeExist(discountCode) {
    const result = await fetch(`/admin/discount_codes/lookup.json?code=${discountCode}`);
    return result.status === 200;
}

// // Loop discounts and assign active
// for (let i = 0; i < discountsToLookup.length; i++) {
//   if(await doesDiscountCodeExist(discountsToLookup[i])) {
//     activeDiscounts.push(discountsToLookup[i])
//   }
// }


/**
  Regex to display SHIM / Bearings Dimensions on product images
**/

var elms = document.querySelectorAll('.src_measurements_placeholder');
for (let el of elms) {
  var html = findMeasurements(el.dataset.title)
  if(html) {
    // console.log(el.innerHtml, html)
    el.innerHTML = html
  }
}

function findMeasurements(title) {
  // For measurements such as 3 x 2 x 1
  var regex = /([0-9.]+)\s?[xX][Φ]?\s?([0-9.]+)(?:\s?[xX][Φ]?\s?([0-9.]+))?/
  // For measurements such as 1/4
  var regex2 = /(?:(\d\/\d)[x\s]+(\d\/\d))/

  var a = title.match(regex)
  var b = title.match(regex2)
  var v = null
  
  if(a != null) {
    v = a
  }
  if(b != null) {
    v = b
  }
   
  if(v == null) 
      return false;
  
  var html = `
  <div class="src_measurements">
    ${v[1]} x ${v[2]} `;

    if(v[3] !== undefined) {
        html += `x ${v[3]} `
    }

  if(v[1].indexOf('/') > -1) {
    html += `</div>`;
  } else {
    html += `mm</div>`; 
  }

  return html
}


// Function to add a list of variants to the Shopify cart
async function SRCaddToCart(variants) {
  try {
    // Iterate through each variant in the list
    for (const { id, quantity } of variants) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id, // Variant ID
          quantity: quantity, // Quantity to add
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to add variant ${id}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log(`Added variant ${id} to cart:`, data);
    }

    // Optionally, redirect to the cart page after adding items
    window.location.href = '/cart';
  } catch (error) {
    console.error('Error adding items to cart:', error);
  }
}

// Example usage:
/*
addToCart([
  { id: '44013184876777', quantity: 1 }, // Variant 1
  { id: '47971191750889', quantity: 2 }, // Variant 2
]);
*/



  function highlightHash() {
    if (window.location.hash) {
      try {
        const target = document.querySelector(window.location.hash);
        if (target && target.classList.contains("highlight-target")) {
          target.style.backgroundColor = "#fff9c4";
          target.style.borderLeft = "4px solid #f9a825";
          target.style.padding = "12px 16px";
          target.style.borderRadius = "4px";
          target.style.transition = "background-color 0.5s ease";
          setTimeout(function() {
            target.scrollIntoView({ behavior: "smooth" });
          }, 100);
        }
      } catch(e) {}
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", highlightHash);
  } else {
    highlightHash();
  }

  window.addEventListener("hashchange", highlightHash);
